import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { IEditReportFolderModel } from "../../entities/edit-report-model";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ReportServices }from "../../scripts/ah.mb.report-services";

interface IMultiSelectItem {
    value: any;
    label: string;
}

@Component
export default class ReportFolderEditorDialog extends Vue {


    @Prop()
    value: IEditReportFolderModel;

    @Prop()
    modelServices: modelServices;

    @Prop()
    reportServices:  ReportServices;

    nodeTypesList: Array<IMultiSelectItem>;
    timePointLookup: string[];


    mounted() {

    }


    onCancelClick() {
        this.$emit("dialogClosed", "cancel");


    }

    onSaveClick() {

        switch (this.value.mode) {
        case "create":
            this.reportServices
                .createScript(this.value.modelId, this.value.path, this.value.name, this.value.nodePathAndName)
                .then(response => {
                    if (response.success)
                        this.$emit("dialogClosed", "ok");
                });
            break;

        case "edit":
        {
            this.reportServices
                .editScript(this.value.modelId, this.value.path, this.value.name, this.value.nodePathAndName)
                .then(response => {
                    if (response.success)
                        this.$emit("dialogClosed", "ok");

                });
        };
        }
    }

    sectorSearchFunction(query: string, done: (any) => void) {
        const url =  this.modelServices.getNodeSearchUrl(this.value.modelId, { searchPathAndName: query });


        FetchWrapper.fetch(url, { method: "get" })
            .then(res => res.json())
            .then((res: any) => {
                var namesOnly = res.map(p => p.name);
                done(namesOnly);
            });
    }



}





// WEBPACK FOOTER //
// ./ClientApp/components/report-folder-editor-dialog/report-folder-editor-dialog.ts